import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import { siderWidth } from '../../../constants/layout'

import statusText from '../../../constants/property';
import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';
import OpenButton from '../../layouts/OpenButton';
import ContraTbl from '../../tables/ContraTbl';
import { contentPadding } from '../../layouts/layoutHelper';

import { FilterProvider } from '../../../context/FilterContext';
import MotionLayout from '../../general/framer-motion/MotionLayout';

const Index = () => {

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    const [searchInputs, setSearchInputs] = useState<any>({
        currency: null,
        type: '' //get first key
    });
    const [currentAccNo, setCurrentAccNo] = useState([]);
    const [inputs, setInputs] = useState({});
    const [accounts, setAccounts] = useState([]);
    
    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };


    const convertPropertyToOptions = (obj:any) => {
        // Convert object entries to array format
        const options = Object.entries(obj).map(([key, value]) => ({
          value: key,
          label: value
        }));
      
        // Add the "All" option at the beginning
        options.unshift({ value: '', label: 'All' });
      
        return options;
    };

    const filterColumns = [
        {
            type: "selectUser",
        },
        {
            type:"selectDateRangePicker"
        },
        {   
            id:"type",
            label:"Type",
            type:"select",
            options:convertPropertyToOptions(statusText.contraTypes)
        },
    ]


    return (
        <MotionLayout>
            <FilterProvider>
                <div className={`page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="side-bar" style={{
                        width: isSidebarCollapsed ? '0' : siderWidth
                    }}>
                        <CloseButton 
                            handleClick={handleSidebarToggle}
                        />
                        <div className='content' style={{width:siderWidth}}>
                            <div className='pt-3'></div>
                          
                            <FilterInputBuilder 
                                loading={tableLoading}
                                columns={filterColumns} 
                                initSearchWhenReceived={[`accounts[]`]}  
                                onSearchSubmit={(inputs:any)=>{
                                    let accounts = inputs['accounts[]'] || [];
                                    setAccounts(accounts)
                                    //force trigger search
                                    setInputs(JSON.parse(JSON.stringify(inputs)));
                                // console.log("12345 contra!!!! set filter "+JSON.stringify(inputs))
                                    //setFilterParams("contra",JSON.parse(JSON.stringify(inputs)));
                                }}
                            />
                         
                        </div>
                    
                    </div>
                    <div className="main-content " style={{
                        marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                        paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                    }}>
                        <OpenButton 
                            isSidebarCollapsed={isSidebarCollapsed}
                            handleClick={handleSidebarToggle}
                        />
                        <div className={ contentPadding(isSidebarCollapsed)}>
                            <div>
                                <div className="main-title">Contra</div>
                                <ContraTbl inputs={inputs}/>
                            </div>
                        </div>
                        
                    
                    </div>
                </div>
            </FilterProvider>
        </MotionLayout>
    );
};

export default Index;




  
